<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BlujayGsoftAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  